import { Controller } from '@hotwired/stimulus';
const { validate, clean, format } = require('rut.js')

let string_pattern = /^[a-zA-Z]+$/
let email_pattern = /\S+@\S+\.\S+/
let userWorksitesField
let hiddenWorksitesField
export default class extends Controller {
  static targets = ["button", "field", "passwordHelp"]
  connect() {
    const locale = document.querySelector('.current_locale')
    I18n.locale = locale ? locale.dataset.locale : 'en'

    this.changeRole()
  }

  checkAllParams() {
    // Safety check: if fieldTargets is empty, don't run validations
    if (!this.hasFieldTarget || this.fieldTargets.length === 0) {
      return
    }

    let enable = true
    let fields = this.fieldTargets
    if (this.checkRut(fields)) { enable = false }
    if (this.checkFirstName(fields)) { enable = false }
    if (this.checkLastName(fields)) { enable = false }
    if (this.checkEmail(fields)) { enable = false }
    if (this.checkPassword(fields)) { enable = false }
    if (this.checkCharge(fields)) { enable = false }

    const userBtn = document.getElementById('userBtn')
    if (userBtn) {
      if (enable) { userBtn.classList.remove('disabled') }
      else { userBtn.classList.add('disabled') }
    }
  }

  checkRut(fields) {
    let field = fields.find(f => f.id == 'rut')
    if (!field) return false
    field.value = format(field.value)
    return !(validate(field.value))
  }

  checkFirstName(fields) {
    let field = fields.find(f => f.id == 'first_name')
    if (!field) return false
    return !(string_pattern.test(field.value))
  }

  checkLastName(fields) {
    let field = fields.find(f => f.id == 'last_name')
    if (!field) return false
    return !(string_pattern.test(field.value))
  }

  checkEmail(fields) {
    let field = fields.find(f => f.id == 'email')
    if (!field) return false
    return !(email_pattern.test(field.value))
  }

  checkPassword(fields) {
    let field = fields.find(f => f.id == 'password')
    if (!field) return false
    let minLength = field.getAttribute('minlength') || 10
    return field.value == "" || field.value.length < minLength
  }

  checkCharge(fields) {
    let field = fields.find(f => f.id == 'charge')
    if (!field) return false
    return field.value == ""
  }

  changeWorksite() {
    const userWorksitesField = document.getElementById('worksite')
    const hiddenWorksitesField = document.getElementById('worksite_hidden')
    if (userWorksitesField && hiddenWorksitesField) {
      hiddenWorksitesField.value = userWorksitesField.value
    }
  }

  changeRole() {
    const roleField = document.getElementById('role')
    const passwordField = document.getElementById('password')
    const userWorksitesField = document.getElementById('worksite')

    if (!roleField || !passwordField) return

    let role = roleField.value

    if (['admin'].includes(role)) {
      if (userWorksitesField) {
        const tecnipakOption = Array.from(userWorksitesField.options).find(opt => opt.textContent === 'TECNIPAK')
        if (tecnipakOption) {
          userWorksitesField.value = tecnipakOption.value
        }
        this.changeWorksite()
        userWorksitesField.disabled = true
      }

      passwordField.setAttribute('minlength', '16')
      passwordField.setAttribute('placeholder', I18n.t('js.password.placeholder_admin'))
      if (this.hasPasswordHelpTarget) {
        this.passwordHelpTarget.textContent = I18n.t('js.password.help_admin')
      }
    }
    else {
      if (userWorksitesField) {
        this.changeWorksite()
        userWorksitesField.disabled = false
      }

      passwordField.setAttribute('minlength', '10')
      passwordField.setAttribute('placeholder', I18n.t('js.password.placeholder_regular'))
      if (this.hasPasswordHelpTarget) {
        this.passwordHelpTarget.textContent = I18n.t('js.password.help_regular')
      }
    }
    this.checkAllParams()
  }
}
